import featureFlags from '../config/location.config';
import { areCitiesEquivalent, getCanonicalCitySlug } from '../config/cityData';

// Fallback to hardcoded config if dynamic data is not available
export const getFeaturesForLocation = (location: string) => {
  // If city is not found in featureFlags, return default with showBookNow: false
  return featureFlags[getCanonicalCitySlug(location)] || { showBookNow: false };
};

// New function to get features dynamically from cities context
export const getDynamicFeaturesForLocation = (location: string, cities: any[]) => {
  if (!location || !cities.length) {
    // Fallback to hardcoded config
    return getFeaturesForLocation(location);
  }
  
  const city = cities.find(c => 
    areCitiesEquivalent(c.name, location)
  );
  
  if (city) {
    return { showBookNow: city.showBookNow };
  }
  
  // Fallback to hardcoded config if city not found
  return getFeaturesForLocation(location);
};
